import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'df-statement-content-wrapper',
  templateUrl: './statement-content-wrapper.component.html',
  styleUrls: ['./statement-content-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatementContentWrapperComponent {}
